import reportScheduleService from '_services/reportSchedule.service';
import ACTIONS_REPORT_SCHEDULE from '_constants/reportSchedule.constants';
import alertActions from './alert.actions';

export const receiveReportSchedules = (reportSchedules) => {
  const byIdObjectToDispatch = {};

  for (let i = 0; i < reportSchedules.length; i++) {
    byIdObjectToDispatch[reportSchedules[i].reportScheduleID] = reportSchedules[i];
  }

  return {
    type: ACTIONS_REPORT_SCHEDULE.RECEIVE,
    byId: byIdObjectToDispatch,
  };
};

export const deleteReportSchedule = (reportScheduleID) => ({
  type: ACTIONS_REPORT_SCHEDULE.DELETE,
  byId: { [reportScheduleID]: null }
});

const searchReportSchedules = ({ reportDefinitionID }) => async (dispatch) => {
  try {
    const resp = await reportScheduleService.search({ reportDefinitionID });
    if (resp?.reportSchedules) {
      dispatch(receiveReportSchedules(resp.reportSchedules));
      return resp.reportSchedules;
    }
  } catch (e) {
    console.error(e);
    dispatch(alertActions.error('Error searching report definitions.'));
  }
  return null;
};

const getReportSchedule = (reportScheduleID) => async (dispatch) => {
  try {
    const resp = await reportScheduleService.getById(reportScheduleID);
    if (resp?.reportSchedule) {
      dispatch(receiveReportSchedules([ resp.reportSchedule ]));
      return resp.reportSchedule;
    }
  } catch (e) {
    console.error(e);
    dispatch(alertActions.error(`Error retrieving report definition: ${reportScheduleID}.`));
  }
  return null;
};

const addReportSchedule = (reportSchedule) => async (dispatch) => {
  try {
    const resp = await reportScheduleService.create(reportSchedule);
    if (resp?.reportSchedule) {
      dispatch(receiveReportSchedules([ resp.reportSchedule ]));
      return resp.reportSchedule;
    }
  } catch (e) {
    console.error(e);
    dispatch(alertActions.error('Error creating report definition.'));
  }
  return null;
};

const updReportSchedule = (reportSchedule) => async (dispatch) => {
  try {
    const resp = await reportScheduleService.update(reportSchedule);
    if (resp?.reportSchedule) {
      dispatch(receiveReportSchedules([ resp.reportSchedule ]));
      return resp.reportSchedule;
    }
  } catch (e) {
    console.error(e);
    dispatch(alertActions.error('Error updating report definition.'));
  }
  return null;
};

const delReportSchedule = (reportScheduleID) => async (dispatch) => {
  try {
    const resp = await reportScheduleService.delete(reportScheduleID);
    if (resp?.reportSchedule) {
      dispatch(deleteReportSchedule(reportScheduleID));
      return resp.reportSchedule;
    }
  } catch (e) {
    console.error(e);
    dispatch(alertActions.error(`Error removing report definition: ${reportScheduleID}.`));
  }
  return null;
};

const reportScheduleActions = {
  searchReportSchedules,
  getReportSchedule,
  addReportSchedule,
  updReportSchedule,
  delReportSchedule
};

export default reportScheduleActions;
